export default {"src":"/_next/static/media/nl-flag.6280f7fa.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};